import { messages } from '../Message'

const GENERIC_FIELD_MESSAGE = 'הערך שהוזן אינו תקין'

export function wordingOf(code, params) {
    const message = messages[code]

    if (message == null) {
        return code
    }

    return typeof message === 'function' ? message(params) : message
}

function pathErrorWording(path, labelOf) {
    const label = labelOf?.(path[0])

    return label == null
        ? GENERIC_FIELD_MESSAGE
        : `ערך לא תקין בשדה ${label}`
}

export function refusalOf(error, { labelOf } = {}) {
    const body = error?.response?.data?.error
    const pathErrors = (body?.details?.errors ?? []).filter((item) => Array.isArray(item.path) && item.path.length > 0)
    const validations = body?.details?.validations ?? []

    const notices = []
    const fieldErrors = {}

    pathErrors.forEach((item) => {
        const wording = pathErrorWording(item.path, labelOf)

        notices.push({
            type: 'error',
            code: wording,
        })
        fieldErrors[item.path[0]] = wording
    })

    validations.forEach((validation) => {
        notices.push({
            type: 'error',
            code: validation.code,
            params: validation.params,
        })

        const field = validation.params?.field
        if (field != null) {
            fieldErrors[field] = wordingOf(validation.code, validation.params)
        }
    })

    if (notices.length === 0) {
        const code = body?.message
        const known = code != null && messages[code] != null

        notices.push({
            type: 'error',
            code: known ? code : 'UNEXPECTED_ERROR',
        })
    }

    return {
        notices,
        fieldErrors,
    }
}
